import React, { useState, useEffect } from "react";
import api from "../../../api/axios";
import toast from "react-hot-toast";
import { ImagePlus, Loader2 } from "lucide-react";

export default function AddGaleryPage() {
  const [tags, setTags] = useState([]);
  const [title, setTitle] = useState("");
  const [selectedTag, setSelectedTag] = useState("");
  const [file, setFile] = useState(null);
  const [preview, setPreview] = useState("");
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    api.get("/galeritag").then((res) => setTags(res.data || [])).catch(() => {});
  }, []);

  const handleFileChange = (e) => {
    const f = e.target.files[0];
    if (f) {
      setFile(f);
      const reader = new FileReader();
      reader.onload = (ev) => setPreview(ev.target.result);
      reader.readAsDataURL(f);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!file) return toast.error("Lütfen bir görsel seçin");
    setSaving(true);

    const data = new FormData();
    const trimmedTitle = title.trim();
    data.append("title", trimmedTitle);
    data.append("imageTitle", trimmedTitle);
    if (selectedTag) {
      data.append("galeriTagId", selectedTag);
      data.append("GaleriTagId", selectedTag);
    }
    data.append("file", file);

    try {
      await api.post("/galeri", data, { headers: { "Content-Type": "multipart/form-data" } });
      toast.success("Görsel yüklendi");
      setTitle(""); setSelectedTag(""); setFile(null); setPreview("");
    } catch { toast.error("Yükleme başarısız"); }
    finally { setSaving(false); }
  };

  return (
    <div className="page-container">
      <div className="page-header">
        <div>
          <h2>Görsel Yükle</h2>
          <p className="page-subtitle">Galeriye yeni görsel ekleyin</p>
        </div>
      </div>

      <form onSubmit={handleSubmit}>
        <div className="content-card" style={{ maxWidth: 600 }}>
          <div className="image-upload-area large">
            {preview ? (
              <div className="image-preview">
                <img src={preview} alt="Preview" />
                <button type="button" className="remove-image" onClick={() => { setFile(null); setPreview(""); }}>×</button>
              </div>
            ) : (
              <label className="upload-placeholder">
                <ImagePlus size={40} />
                <span>Görsel seçmek için tıklayın</span>
                <small>PNG, JPG, WEBP (max 5MB)</small>
                <input type="file" accept="image/*" onChange={handleFileChange} hidden />
              </label>
            )}
          </div>

          <div className="form-field">
            <label>Başlık</label>
            <input type="text" value={title} onChange={(e) => setTitle(e.target.value)} className="form-input" placeholder="Görsel başlığı" />
          </div>

          <div className="form-field">
            <label>Etiket</label>
            <select value={selectedTag} onChange={(e) => setSelectedTag(e.target.value)} className="form-input">
              <option value="">Etiket seçiniz (opsiyonel)</option>
              {tags.map((t) => <option key={t.galeriTagId} value={t.galeriTagId}>{t.tagName}</option>)}
            </select>
          </div>

          <button type="submit" className="btn btn-primary btn-full" disabled={saving}>
            {saving ? <><Loader2 size={18} className="spin" /> Yükleniyor...</> : "Yükle"}
          </button>
        </div>
      </form>
    </div>
  );
}
